/**
 * A readable message for a failed API call, instead of "Une erreur est
 * survenue." for everything — which is what left the expert stuck on the
 * preset form without knowing why.
 */
export function apiErrorMessage(err, t) {
  const status = err?.response?.status;
  const detail = err?.response?.data?.detail;

  if (!err?.response) return t('errors.network');
  if (status === 401) return t('errors.sessionExpired');
  if (status === 403) return t('errors.forbidden');
  if (typeof detail === 'string' && detail) return detail;
  // FastAPI validation errors: [{loc: [..., "default_price"], msg: "..."}]
  if (Array.isArray(detail) && detail.length) {
    const field = detail[0]?.loc?.[detail[0].loc.length - 1];
    return field
      ? t('errors.invalidField', { field: t(`errors.fields.${field}`, { defaultValue: field }) })
      : t('errors.generic');
  }
  return t('errors.generic');
}
